import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type TrackSavedFilter } from '../types';

export const useTrackViewedSavedFilter = () => {
  const { track } = useAnalyticsUtilities();

  const trackViewedSavedFilter = useCallback(
    (params: TrackSavedFilter) => {
      track(`Viewed saved filter`, params);
    },
    [track],
  );

  return { trackViewedSavedFilter };
};
